export const organization = {
  routes: [
    {
      path: "/organization/announcement",
      component: () => import("../organization-announcement-view"),
    },
  ],
};
